@if (isFreeDowngrade()) {
  <h1 class="text-4xl font-extrabold text-default">
    {{ "Let's adjust your account for the [planName] plan" | translate: { planName: planName() } }}
  </h1>
  <div class="text-xl font-medium text-default">
    {{
      'To switch to [planName] and pick up where you left off, you’ll first have to update a few things so your account fits within the plan’s limits.'
        | translate: { planName: planName() }
    }}
  </div>
} @else {
  <h1 class="text-4xl font-extrabold text-default">
    {{ 'Your account has been successfully downgraded to [planName]!' | translate: { planName: planName() } }}
  </h1>
  <div class="text-xl font-medium text-default">
    {{
      'To fit within the limits of [planName] and pick up where you left off, you’ll have to update a few things in the organizational structure.'
        | translate: { planName: planName() }
    }}
  </div>
}
<div class="mt-10 flex justify-end">
  <button sb-button [color]="'primary'" class="w-full max-w-fit" (click)="next.emit()">
    {{ 'Next' | translate }}
  </button>
</div>
